export interface IContainer {
  id: string;
  name: string;
  client_id?: number;
  container_type?: string;
  service_principals?: string[];
  client_name?: string | null;
  description?: string;
  created_at?: string;
}

export interface IContainersPaginatedResponse {
  containers: IContainer[];
  page: number;
  page_size: number;
  total_count: number;
  total_pages?: number;
  has_previous_page?: boolean;
  has_next_page?: boolean;
}

export interface IContainerItem {
  id: string;
  name: string;
  type: 'file' | 'folder';
  created_at: string;
  modified_at: string;
  modified_by: string;
  parent_id: string | null;
  size: number | null;
  container_id: string;
}
export interface IContainerItemListResponse {
  items: IContainerItem[],
  page: number,
  page_size: number,
  total_count: number
}

/**
 * Maps API response to IContainerItem with backward compatibility
 */
export function mapToContainerItem(apiItem: any): IContainerItem {
  return {
    id: apiItem.id,
    name: apiItem.name,
    type: apiItem.type,
    created_at: apiItem.created_at,
    modified_at: apiItem.modified_at,
    modified_by: apiItem.modified_by,
    parent_id: apiItem.parent_id,
    size: apiItem.size,
    container_id: apiItem.container_id,
  };
}
